(function() {
    $(document).ready(function() {
        const product = $('.mod24ac:not(.mini)').data('product');

        // ppset
        if (
            product === 'versicherungen' &&
            (
                document.querySelectorAll('.mod24ac.date').length === 0 &&
                document.querySelectorAll('.mod24ac.rv').length === 0
            )
        ) {
            return;
        }

        if (product !== 'sofortrente-einmalbeitrag' && !$('.mod24ac.rv:not(.mini)')) {
            return;
        }

        const oIpss = $.extend(true, {}, window.c24.lp.ipssReforged);

        oIpss.tilesOrder = [
            'incompleteContracts',
            'offers',
            'lastSearches',
            'contracts',
            'productSpecificTiles',
            'staticTiles',
        ];

        oIpss.bThousandsSeparator = true;
        oIpss.fittingTariffsWithDate = true;
        oIpss.iSortItems = 1;

        oIpss.sDeleteMethod = 'DELETE';
        oIpss.hideSubtextWhenIpssIsActive = false;

        oIpss.tileHeadlineMap.lastSearches = 'Ihr Vergleich';
        oIpss.tileHeadlineMap.staticTile = 'Haben Sie Fragen?';
        oIpss.tileHeadlineMap.offer = 'Ihr Angebot';
        oIpss.tileHeadlineMap.incompleteContract = 'Ihr Antrag';

        oIpss.bCommaAfterPerson = false;
        oIpss.bCommaAfterPersonJob = false;

        oIpss.iconMap = {
            'sofort': '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" fill="#666"><path d="M183.4 165.04l-27.39-18.27v-41.86c0-3.31-2.7-6.01-6.01-6.01s-6.01 2.7-6.01 6.01V150c0 1.99.99 3.85 2.67 5l30.06 20.04a5.97 5.97 0 0 0 3.32 1c1.94 0 3.85-.93 5.01-2.66a6.03 6.03 0 0 0-1.65-8.34zm-.04 45.49c-9.9 5.48-21.27 8.61-33.36 8.61-38.12 0-69.13-31.01-69.13-69.13S111.88 80.87 150 80.87s69.14 31.01 69.14 69.14c0 13.96-4.17 26.96-11.32 37.85 4.81-1.86 10.02-2.91 15.47-3 5.04-10.56 7.88-22.38 7.88-34.85 0-44.75-36.41-81.15-81.15-81.15s-81.15 36.41-81.15 81.15 36.41 81.15 81.15 81.15a80.74 80.74 0 0 0 29.21-5.46c.49-5.38 1.93-10.5 4.15-15.16zm52.48 44.58h-3.59c-9.54 0-18.04-5.32-22.21-13.74h21.01a5.1 5.1 0 0 0 5.09-5.09c0-2.81-2.28-5.09-5.09-5.09h-23.59l-.01-.89.01-.89h23.59a5.1 5.1 0 0 0 5.09-5.09c0-2.81-2.28-5.09-5.09-5.09h-21.01c4.17-8.41 12.66-13.74 22.21-13.74h3.59a5.1 5.1 0 0 0 5.09-5.09c0-2.81-2.28-5.09-5.09-5.09h-3.59c-14.99 0-28.47 9.78-33.18 23.91h-3.88a5.1 5.1 0 0 0-5.09 5.09c0 2.81 2.28 5.09 5.09 5.09h2.1l-.01.89.01.89h-2.1a5.1 5.1 0 0 0-5.09 5.09c0 2.81 2.28 5.09 5.09 5.09h3.88c4.71 14.13 18.19 23.91 33.18 23.91h3.59a5.1 5.1 0 0 0 5.09-5.09c0-2.81-2.28-5.09-5.09-5.09zm-52.93-6.98c-10.34 3.48-21.41 5.37-32.91 5.37-57.07 0-103.5-46.43-103.5-103.5S92.93 46.5 150 46.5 253.5 92.93 253.5 150c0 14.25-2.9 27.84-8.13 40.21 3.64 1.96 6.97 4.42 9.91 7.27 6.56-14.49 10.22-30.57 10.22-47.48 0-63.69-51.81-115.5-115.5-115.5S34.5 86.31 34.5 150 86.31 265.5 150 265.5c13.83 0 27.1-2.45 39.4-6.92-2.62-3.15-4.8-6.66-6.49-10.44z"/></svg>',
            'rente': '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" fill="#666"><path d="M197.96 230.93l-7.29 3.12-1.04.38-11.39-40.01h8.11c.17-1.39.42-2.75.72-4.1a13.67 13.67 0 0 1 1.52-5.33l.94-2.44H99.57c-2.07 0-3.89-1.4-4.43-3.41-.91-4.43-11.02-70.16-17.64-113.58l6.78-1.02c.14-.02.27-.02.41-.04 7.19-.85 13.84 4.15 14.93 11.36l6.3 41.81c-7.96.12-14.42 6.63-14.43 14.62v.89h0c0 8.06 6.57 14.62 14.62 14.63h4.35l3.38 22.39h67.64.1a13.05 13.05 0 0 1 1.09.05c.13.01.26.03.39.04a10.52 10.52 0 0 1 .81.12c.12.02.24.04.37.07a14.73 14.73 0 0 1 .9.22l.22.06a12.48 12.48 0 0 1 2.24.9c.01 0 .03.01.04.02.35.18.69.37 1.02.58.02.01.03.02.05.03 1.02.65 1.96 1.43 2.77 2.33a.5.5 0 0 0 .07.08 12.06 12.06 0 0 1 .64.78c.07.09.14.18.2.27.13.17.24.35.36.53a52.42 52.42 0 0 1 6.85-8.96c-4.42-4.67-10.95-8.99-18.1-8.99h-4.62l2.04-10.52h11.02c8.05 0 14.62-6.57 14.62-14.63v-.89c0-8.05-6.57-14.62-14.62-14.62h-72l-6.57-43.57c-2.08-13.82-15.03-23.38-28.85-21.29l-8.81 1.33a9.85 9.85 0 0 0-8.24 11.2l8.84 57.7 9.29 58.68h-.05l.13.5c1.92 7.19 8.46 12.22 15.91 12.23h8.77l-11.3 39.7c-8.75-3.31-16.15-7.45-22-12.33a6.73 6.73 0 0 0-9.46.86c-2.37 2.85-1.98 7.09.87 9.46 17.6 14.65 46.52 23.4 77.35 23.4 24.31 0 47.28-5.34 64.9-15.04-4.03-2.78-7.64-5.98-10.73-9.53zm-33.19-72.62h-40.71l-1.59-10.52h44.34l-2.04 10.52zm25.15-28.78c1.52 0 2.75 1.24 2.75 2.75v.89c0 1.14-.7 2.11-1.68 2.53a2.73 2.73 0 0 1-1.07.22h-83.8c-1.52 0-2.75-1.24-2.75-2.75v-.89c0-1.52 1.24-2.75 2.75-2.75h83.8zM108.37 237.7l12.32-43.28h45.21l12.38 43.51a145.96 145.96 0 0 1-69.92-.23zm129.45-10.43h-3.59c-9.54 0-18.04-5.32-22.21-13.74h21.01a5.1 5.1 0 0 0 5.09-5.09c0-2.81-2.28-5.09-5.09-5.09h-23.59l-.01-.89.01-.89h23.59a5.1 5.1 0 0 0 5.09-5.09c0-2.81-2.28-5.09-5.09-5.09h-21.01c4.17-8.41 12.66-13.74 22.21-13.74h3.59a5.1 5.1 0 0 0 5.09-5.09c0-2.81-2.28-5.09-5.09-5.09h-3.59c-14.99 0-28.47 9.78-33.18 23.91h-3.88a5.1 5.1 0 0 0-5.09 5.09c0 2.81 2.28 5.09 5.09 5.09h2.1l-.01.89.01.89h-2.1a5.1 5.1 0 0 0-5.09 5.09c0 2.81 2.28 5.09 5.09 5.09h3.88c4.71 14.13 18.19 23.91 33.18 23.91h3.59a5.1 5.1 0 0 0 5.09-5.09c0-2.81-2.28-5.09-5.09-5.09z"/></svg>',
        };

        let sRenteApiUrl = '';
        let apiUrlPrefix = '';
        let teaserId = 'rv';

        if (product === 'sofortrente-einmalbeitrag' || document.querySelectorAll('.mod24ac.date:not(.mini)').length > 0) {
            apiUrlPrefix = '/sofort';
            teaserId = 'date';

            oIpss.hideSubtextWhenIpssIsActive = true;
        }

        if (window.c24LpDomain === '.check24-test.de') {
            sRenteApiUrl = 'https://services.rente.check24-test.de/router-service/tariff-searches' + apiUrlPrefix;
        } else {
            sRenteApiUrl = 'https://services.rente.check24.de/desktop-api/tariff-searches' + apiUrlPrefix;
        }

        // special behaviour for mailing lps
        const regexMailing = /^.*\/crm\//;
        const currentUrl = new URL(document.URL);
        const isPromoLp = regexMailing.test(currentUrl.pathname);

        if (isPromoLp) {
            oIpss.showGreeting = false;
        }


        oIpss.renderDataArrayProductSpecificTileHeadline = function(sRenderType, data) {
            if (!data || sRenderType !== 'productSpecificTile') {
                return false;
            }

            if (data.type === 'rentenluecke') {
                if (this.bIsMobile && data.inputs.pensionGap) {
                    return 'Jetzt Rentenlücke schließen';
                }
                return 'RentenlückenCHECK';
            }

            return data?.headline?.text ?? this.tileHeadlineMap[sRenderType] ?? null;
        };

        // tmp headline handling while incompleteContracts and lastSearches only
        // remove when displaying tab navi
        oIpss.renderHeadline = function(data) {
            if (!oIpss.bUseTilesLayout) { // remove when all ipss are tiles layout
                const self = this;
                let amountHeadline;
                let typeHeadline;
                let amountHeadlineExtend = '';
                const newHeadline = {};
                const $headlineShowEverything = $('[id^="lastSearches"] .ipssHeadline.lastSearches', this.domContext);
                const $tabHeadlineLastSearches = $('.cssTabHeaderItem[data-contentbox^="lastSearches"]', this.domContext);
                const iAmountNonContracts = data.contracts ? data.contracts.length : 0;

                if (!self.isValidApiResponse(data)) {

                    newHeadline.general = 'Meine letzte Aktivität';
                    newHeadline.lastSearches = 'Meine letzten Vergleiche';
                } else {
                    if (data.contracts && iAmountNonContracts > 0) {

                        amountHeadlineExtend = '';
                        if (iAmountNonContracts < 2) {

                            typeHeadline = 'Antrag';
                            amountHeadline = 'Mein ';
                        } else {

                            typeHeadline = 'Anträge';
                            amountHeadline = 'Meine  ';
                        }

                        newHeadline.general = amountHeadline + typeHeadline + amountHeadlineExtend;
                    }

                    if (data.lastSearches) {

                        typeHeadline = 'Vergleich';

                        if (data.lastSearches.length < 2) {
                            amountHeadline = 'Mein letzter ';
                            amountHeadlineExtend = '';
                        } else {
                            amountHeadline = 'Meine letzten ';
                            amountHeadlineExtend = 'e';
                        }

                        newHeadline.lastSearches = amountHeadline + typeHeadline + amountHeadlineExtend;
                    }
                }

                if (self.bShowContracts) {

                    if (iAmountNonContracts < 1 && data.lastSearches) {
                        newHeadline.general = newHeadline.lastSearches;
                        newHeadline.lastSearches = null;
                    }

                    $tabHeadlineLastSearches.text(newHeadline.general);

                    if (newHeadline.lastSearches === null) {
                        $headlineShowEverything.remove();
                    } else {
                        $headlineShowEverything.text(newHeadline.lastSearches);
                    }

                } else {
                    $('[id^="lastSearches"] .ipssHeadline.nonContracts', this.domContext).text(newHeadline.general);
                    $headlineShowEverything.text(newHeadline.lastSearches);
                }
            } else {
                const self = this;
                let amountHeadline;
                let typeHeadline;
                let amountHeadlineExtend = '';
                const newHeadline = {};
                const $headlineShowEverything = $('[id^="lastSearches"] .ipssHeadline.lastSearches', self.domContext);
                const $tabHeadlineLastSearches = $('.cssTabHeaderItem[data-contentbox^="lastSearches"]', self.domContext);

                self.iAmountNonContracts = data.contracts ? data.contracts.length : 0;
                self.iAmountLastSearches = data.lastSearches ? data.lastSearches.length : 0;
                self.iAmountTotal = self.iAmountNonContracts + self.iAmountLastSearches;

                if (!self.isValidApiResponse(data)) {

                    newHeadline.general = 'Meine letzte Aktivität';
                    newHeadline.lastSearches = 'Meine letzten Vergleiche';
                } else {
                    if (data.contracts && self.iAmountNonContracts > 0) {

                        typeHeadline = 'Aktivität';

                        if (self.iAmountTotal < 2) {
                            amountHeadline = 'Meine letzte ';
                            amountHeadlineExtend = '';
                        } else {
                            amountHeadline = 'Meine letzten ';
                            amountHeadlineExtend = 'en';
                        }

                        newHeadline.general = amountHeadline + typeHeadline + amountHeadlineExtend;
                    }

                    if (data.lastSearches) {

                        typeHeadline = 'Vergleich';

                        if (data.lastSearches.length < 2) {
                            amountHeadline = 'Mein letzter ';
                            amountHeadlineExtend = '';
                        } else {
                            amountHeadline = 'Meine letzten ';
                            amountHeadlineExtend = 'e';
                        }

                        newHeadline.lastSearches = amountHeadline + typeHeadline + amountHeadlineExtend;
                    }
                }

                if (self.bShowContracts) {

                    if (self.iAmountNonContracts < 1 && data.lastSearches) {
                        newHeadline.general = newHeadline.lastSearches;
                        newHeadline.lastSearches = null;
                    }

                    $tabHeadlineLastSearches.text(newHeadline.general);

                    if (newHeadline.lastSearches === null && self.aAppointmentsGrouped?.length < 0) {
                        $headlineShowEverything.remove();
                    } else {
                        $headlineShowEverything.text(newHeadline.lastSearches);
                    }

                } else {
                    $('[id^="lastSearches"] .ipssHeadline.nonContracts', self.domContext).text(newHeadline.general);
                    $headlineShowEverything.text(newHeadline.lastSearches);
                }

                if (self.bUseTilesLayout && self.bIsMobile) {
                    $('.ipssHeadline.activities', self.domContext).text(`Meine Aktivitäten (${self.iAmountTotal})`);
                }
            }
        };

        oIpss.renderProductSpecificLabels = function (data) {
            const dataInputs = data.inputs;
            const labels = {};

            const productTypeMap = {
                'riester': 'Riester-Rente',
                'ruerup': 'Rürup-Rente',
                'schicht3': 'Flexible Privatrente',
                'sofort': 'Sofort-Rente',
                's3einmalzahlung': 'Rente gegen Einmalbeitrag',
            };

            let paymentPeriodMap = {
                'once': 'einmaliger',
                'monthly': 'monatlicher',
                'yearly': 'jährlicher',
            };

            if (oIpss.bUseTilesLayout) {
                oIpss.bDecimalSeparator = false;

                productTypeMap.s3einmalzahlung = 'Einmalbeitrag-Rente';

                oIpss.periodMap = {
                    'once': 'einmal.',
                    'monthly': 'monatl.',
                    'yearly': 'jährl.',
                };

                paymentPeriodMap = {
                    'once': 'einmal.',
                    'monthly': 'monatl.',
                    'yearly': 'jährl.',
                };
            }


            if (!dataInputs) {
                return labels;
            }

            if (dataInputs.productType && productTypeMap[dataInputs.productType]) {
                labels.productType = productTypeMap[dataInputs.productType];
            } else {
                labels.productType = null;
            }

            if (dataInputs.payment) {
                labels.paymentPeriod = paymentPeriodMap[dataInputs.payment?.period] ? paymentPeriodMap[dataInputs.payment?.period] + ' ' : null;

                if (!this.bIsMobile && labels.paymentPeriod !== null) {
                    labels.paymentPeriod = labels.paymentPeriod.toLowerCase();
                }

                labels.paymentPrice = dataInputs.payment?.price ? oIpss.formatPrice(dataInputs.payment.price) : null;
            } else {
                labels.paymentPeriod = null;
                labels.paymentPrice = null;
            }

            if (dataInputs.retirementAge) {
                labels.retirementAge = dataInputs.retirementAge + ' Jahren';

            } else {
                labels.retirementAge = null;
            }

            if (dataInputs.extraPayment) {
                labels.extraPayment = oIpss.formatPrice(dataInputs.extraPayment);
            } else {
                labels.extraPayment = null;
            }

            labels.pensionGap = null;
            labels.lastUpdate = null;

            if (!dataInputs.pensionGap && data.type === 'rentenluecke') {
                labels.lastUpdate = 'zuletzt besucht';
                return labels;
            }

            labels.messageText = null;

            if (dataInputs.pensionGap) {
                labels.pensionGap = oIpss.formatPrice(dataInputs.pensionGap);
                if (this.bIsMobile) {
                    labels.lastUpdate = 'berechnet';
                }
            }

            return labels;
        };

        oIpss.renderLinkingDelete = function(element, data) {
            if (!oIpss.bUseTilesLayout) { // remove when all ipss are tiles layout
                const self = this;

                if (this.bIsMobile && !oIpss.bUseTilesLayout) {
                    $('.delete', element).on('click', function(e) {
                        e.preventDefault();
                        e.stopPropagation();

                        const jSelf = $(this).parent('.metaData');

                        if (jSelf.data('deletelink')) {
                            self.removeIpssItem(jSelf, self);
                        }

                        return false;
                    });

                } else {
                    $('.delete', element).on('click', function(e) {
                        e.preventDefault();
                        e.stopPropagation();

                        const jSelf = $(this);
                        self.removeIpssItem(jSelf, self);

                        return false;
                    });
                }

                const metaDataContainer = $('.metaData', element);

                if (data.urlDelete != null) {
                    if (this.bIsMobile && !oIpss.bUseTilesLayout) {
                        metaDataContainer.data('deletelink', data.urlDelete);
                    } else {
                        if ($('.delete', metaDataContainer).length) {
                            $('.delete', metaDataContainer).data('deletelink', data.urlDelete);
                        } else {
                            $('.delete', element).data('deletelink', data.urlDelete);
                        }
                    }
                } else {
                    if (this.bIsMobile) {
                        $('.delete', metaDataContainer).remove();
                    } else {
                        if ($('.delete', metaDataContainer).length) {
                            $('.delete', metaDataContainer).remove();
                        } else {
                            $('.delete', element).remove();
                        }
                    }
                }
            } else {
                const self = this;

                if (self.bIsMobile && !self.bUseTilesLayout) {
                    $('.metaData', element).on('click', function(e) {
                        e.preventDefault();
                        e.stopPropagation();

                        if ($(this).find('.delete').length < 1) {
                            return false;
                        }

                        const jSelf = $(this);

                        if (jSelf.data('deletelink')) {
                            self.removeIpssItem(jSelf, self);
                        }

                        return false;
                    });

                } else {
                    $('.delete', element).on('click', function(e) {
                        e.preventDefault();
                        e.stopPropagation();

                        const jSelf = $(this);
                        self.removeIpssItem(jSelf, self);

                        return false;
                    });
                }

                const metaDataContainer = $('.metaData', element);

                if (data.urlDelete != null) {
                    if (self.bIsMobile && !self.bUseTilesLayout) {
                        metaDataContainer.data('deletelink', data.urlDelete);
                    } else {
                        if ($('.delete', metaDataContainer).length) {
                            $('.delete', metaDataContainer).data('deletelink', data.urlDelete);
                        } else {
                            $('.delete', element).data('deletelink', data.urlDelete);
                        }
                    }
                } else {
                    if (self.bIsMobile && !self.bUseTilesLayout) {
                        $('.delete', metaDataContainer).remove();
                    } else {
                        if ($('.delete', metaDataContainer).length) {
                            $('.delete', metaDataContainer).remove();
                        } else {
                            $('.delete', element).remove();
                        }
                    }
                }
            }
        };

        oIpss.renderDataArrayTariffDetails = function(data) {
            const aDataArray = {};
            const self = this;
            const price = data.price ?? data.best.price;
            let priceUnit;
            let period;

            aDataArray.tariff = {};

            if (Object.keys(data).length === 0) {
                aDataArray.tariff.count = null;

                aDataArray.tariff.price = null;

                aDataArray.tariff.period = null;

                return aDataArray;
            }

            // set period
            if (data.period) {
                period = data.period;
            } else if (data.best && data.best.period) {
                period = data.best.period;
            } else {
                period = null;
            }

            // set count
            if (data.count) {
                let countTextSuffix = '';
                let numerus = 'Tarif';

                if (data.count === 1) {
                    if (!self.bIsMobile) {
                        countTextSuffix = ' mit';
                    }
                } else {
                    numerus += 'e';

                    if (!self.bIsMobile) {
                        countTextSuffix = ' bis zu';
                    }
                }

                aDataArray.tariff.count = data.count + ' ' + numerus + countTextSuffix;
            } else {
                aDataArray.tariff.count = 'bis zu';
            }

            // set priceUnit
            if (data.priceUnit != null) {
                priceUnit = data.priceUnit;
            } else if (data.best && data.best.priceUnit) {
                priceUnit = data.best.priceUnit;
            } else {
                priceUnit = self.defaultPriceUnit;
            }

            // set price
            aDataArray.tariff.price = price ? self.formatPrice(price, priceUnit) : null;

            // set period
            if (period) {
                aDataArray.tariff.period = self.periodMap[period.toLowerCase()];

                if (!oIpss.bUseTilesLayout) {
                    aDataArray.tariff.period += 'e';
                }

                aDataArray.tariff.period += ' Rente';

                if (self.bIsMobile && !oIpss.bUseTilesLayout) {
                    aDataArray.tariff.period += ' bis';
                }
            } else {
                aDataArray.tariff.period = null;
            }

            return aDataArray;
        };

        oIpss.overrideData = {
            'version': 1,
            'lastUpdate': 1637903600, // time of latest search
            'lastSearches': [
                {
                    'time': 1641497137,
                    'deviceOutput': 'desktop',
                    'result': {
                        'cta': {
                            'type': 'primary',
                            'text': 'Vergleich fortsetzen',
                            'urlDesktop': 'LINK TO RESULTPAGE',
                            'urlMobile': 'MOBILE LINK TO RESULTPAGE',
                        },
                        'tariff': {
                            'best': {
                                'period': 'yearly',
                                'price': 5600.2,
                            },
                        },
                        'inputs': {
                            'icon': 'rente',
                            'productType': 'riester', // riester && ruerup && schicht3 && sofort && s3einmalzahlung
                            'payment': {
                                'period': 'monthly',
                                'price': 150.0,
                            },
                            'persons': [
                                {
                                    'birthday': '12.12.1992',
                                },
                            ],
                            'fittingTariffs': 5,
                        },
                        'urlDelete': 'DELETION URL',
                    },
                },
                {
                    'time': 1641497137,
                    'deviceOutput': 'desktop',
                    'result': {
                        'cta': {
                            'type': 'primary',
                            'text': 'Vergleich fortsetzen',
                            'urlDesktop': 'LINK TO RESULTPAGE',
                            'urlMobile': 'MOBILE LINK TO RESULTPAGE',
                        },
                        'tariff': {
                            // 'count': 3, // number of tariffs on result page
                            'best': {
                                // Get tariff with highest possible pension value
                                'period': 'yearly', // always yearly
                                'price': 5600.2, // yearly pension value in EUR
                            },
                        },
                        'inputs': {
                            'icon': 'rente',
                            'productType': 'ruerup', // riester OR ruerup OR schicht3
                            'payment': {
                                'period': 'monthly', // always monthly
                                'price': 150.0, // regular payment in EUR
                            },
                            'persons': [
                                {
                                    'birthday': '12.12.1992',
                                },
                            ],
                            'retirementAge': 60,
                            'extraPayment': 1200.0, // additional one-time payment in EUR. Might be null
                            'fittingTariffs': 11,
                        },
                        'urlDelete': 'DELETION URL',
                    },
                },
                {
                    'time': 1729520326,
                    'deviceOutput': 'desktop',
                    'result': {
                        'cta': {
                            'type': 'primary',
                            'text': 'Vergleich fortsetzen',
                            'urlDesktop': 'LINK TO RESULTPAGE',
                            'urlMobile': 'MOBILE LINK TO RESULTPAGE',
                        },
                        'tariff': {
                            // 'count': 18,
                            'best': {
                                'period': 'yearly',
                                'price': 7800.43,
                            },
                        },
                        'inputs': {
                            'icon': 'rente',
                            'productType': 'schicht3',
                            'payment': {
                                'period': 'monthly',
                                'price': 120.0,
                            },
                            'persons': [
                                {
                                    'birthday': '12.12.1992',
                                },
                            ],
                            'retirementAge': 64,
                            'extraPayment': null,
                            'fittingTariffs': 23,
                        },
                        'urlDelete': 'DELETION URL',
                    },
                },
                {
                    'time': 1729520326,
                    'deviceOutput': 'desktop',
                    'result': {
                        'cta': {
                            'type': 'primary',
                            'text': 'Vergleich fortsetzen',
                            'urlDesktop': 'LINK TO RESULTPAGE',
                            'urlMobile': 'MOBILE LINK TO RESULTPAGE',
                        },
                        'tariff': {
                            // 'count': 18,
                            'best': {
                                'period': 'yearly',
                                'price': 7800.43,
                            },
                        },
                        'inputs': {
                            'icon': 'sofort',
                            'productType': 'sofort',
                            'payment': {
                                'period': 'monthly',
                                'price': 120.0,
                            },
                            'persons': [
                                {
                                    'birthday': '12.12.1992',
                                },
                            ],
                            'retirementAge': 68,
                            'extraPayment': null,
                            'fittingTariffs': 23,
                        },
                        'urlDelete': 'DELETION URL',
                    },
                },
                {
                    'time': 1729520326,
                    'deviceOutput': 'desktop',
                    'result': {
                        'cta': {
                            'type': 'primary',
                            'text': 'Vergleich fortsetzen',
                            'urlDesktop': 'LINK TO RESULTPAGE',
                            'urlMobile': 'MOBILE LINK TO RESULTPAGE',
                        },
                        'tariff': {
                            // 'count': 18,
                            'best': {
                                'period': 'yearly',
                                'price': 7800.43,
                            },
                        },
                        'inputs': {
                            'icon': 'rente',
                            'productType': 's3einmalzahlung',
                            'payment': {
                                'period': 'monthly',
                                'price': 120.0,
                            },
                            'persons': [
                                {
                                    'birthday': '12.12.1992',
                                },
                            ],
                            'retirementAge': 65,
                            'extraPayment': null,
                            'fittingTariffs': 23,
                        },
                        'urlDelete': 'DELETION URL',
                    },
                },
            ],
            'contracts': [
                {
                    'time': 1574784512,
                    'type': 'incompleteContract',
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'jetzt online abschließen',
                            'urlDesktop': 'URL',
                            'urlMobile': 'URL',
                        },
                    ],
                    'tariff': {
                        'name': 'Tarif Best Invest',
                        'period': 'yearly',
                        'price': 5141,
                    },
                    'insuranceKey': 'hdi',
                    'status': {
                        'text': 'Antrag in Bearbeitung',
                        'color': 'yellow',
                    },
                    'inputs': {
                        'productType': 's3einmalzahlung',
                        'payment': {
                            'period': 'monthly',
                            'price': 100,
                        },
                    },
                    'urlDelete': 'https://urlDelete',
                },
                {
                    'time': 1574784512,
                    'type': 'offer',
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'jetzt online abschließen',
                            'urlDesktop': 'URL',
                            'urlMobile': 'URL',
                        },
                    ],
                    'tariff': {
                        'name': 'Privatrente NFX3200',
                        'period': 'yearly',
                        'price': 5141,
                    },
                    'insuranceKey': 'nuernberger',
                    'status': {
                        'text': 'Antrag in Bearbeitung',
                        'color': 'yellow',
                    },
                    'inputs': {
                        'productType': 's3einmalzahlung',
                        'payment': {
                            'period': 'monthly',
                            'price': 100,
                        },
                    },
                    'urlDelete': 'https://urlDelete',
                },
                {
                    'time': 1574784512,
                    'type': 'contract',
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'jetzt online abschließen',
                            'urlDesktop': 'URL',
                            'urlMobile': 'URL',
                        },
                    ],
                    'tariff': {
                        'name': 'MeinPlan Tarif FRV',
                        'period': 'yearly',
                        'price': 5141,
                    },
                    'insuranceKey': 'lv',
                    'status': {
                        'text': 'aktiv: seit 01.01.2020',
                        'color': 'green',
                    },
                    'inputs': {
                        'productType': 's3einmalzahlung',
                        'payment': {
                            'period': 'monthly',
                            'price': 100,
                        },
                    },
                    'urlDelete': 'https://urlDelete',
                },
            ],
            'productSpecificTiles': [
                {
                    'time': 1574784512, //  berechnet oder zuletzt besucht
                    'type': 'rentenluecke',
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'Jetzt Rentenlücke schließen',
                            'urlDesktop': 'URL',
                            'urlMobile': 'URL',
                        },
                    ],
                    'inputs': {
                        'pensionGap': 1300,
                    },
                    'urlDelete': 'https://urlDelete',
                },
                {
                    'time': 1747211352, //  berechnet oder zuletzt besucht
                    'type': 'rentenluecke',
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'RentenlückenCHECK fortsetzen',
                            'urlDesktop': 'URL',
                            'urlMobile': 'URL',
                        },
                    ],
                    'inputs': {
                        'pensionGap': null, // wenn null, dann `Finden Sie heraus...`
                    },
                    'urlDelete': 'https://urlDelete',
                },
            ],
            'staticTiles': [
                {
                    'consultant': {
                        'persons': [
                            {
                                'firstName': 'Maurizio',
                                'lastName': 'Festini',
                                'job': 'Temple Anwärter',
                            },
                        ],
                        'phoneNumber': '089 70809 177261',
                        'image': {
                            'urlDesktop': 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/7.png',
                            'urlMobile': {
                                'default': 'https://www.check24.de/berufsunfaehigkeitsversicherung/data/img/altersvorsorge/test/profilbildRebot.png',
                                'highRes': 'https://www.check24.de/berufsunfaehigkeitsversicherung/data/img/altersvorsorge/test/profilbildRebot.png',
                            },
                            'urlApp': 'https://www.check24.de/berufsunfaehigkeitsversicherung/data/img/altersvorsorge/test/profilbildRebot.png',
                            'urlTabletApp': 'https://www.check24.de/berufsunfaehigkeitsversicherung/data/img/altersvorsorge/test/profilbildRebot.png',
                        },
                    },
                },
            ],

        };

        oIpss.bind(teaserId, sRenteApiUrl, $('.mod24ac.' + teaserId));
    });
})();
